/**
 * @generated SignedSource<<6ddd18863e2a61a00004cb181111aeaf>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type optimisticUpdatesSelectedOptionsQuery$data = {
  readonly edges: ReadonlyArray<{
    readonly fieldSets?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __id: string;
          readonly fields: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly __typename: string;
                readonly __id: string;
                readonly fieldId: string;
                readonly fieldOption?: {
                  readonly optionId: string;
                } | null | undefined;
                readonly selectedOptions?: {
                  readonly edges: ReadonlyArray<{
                    readonly __id: string;
                    readonly node: {
                      readonly id: string;
                      readonly value: string | null | undefined;
                    } | null | undefined;
                  } | null | undefined> | null | undefined;
                } | null | undefined;
                readonly type: string;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "optimisticUpdatesSelectedOptionsQuery";
};
export type optimisticUpdatesSelectedOptionsQuery$key = {
  readonly " $data"?: optimisticUpdatesSelectedOptionsQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"optimisticUpdatesSelectedOptionsQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "optimisticUpdatesSelectedOptionsQuery"
};

(node as any).hash = "83a7011bc7cd3ad661e263d72491a025";

export default node;
